"use client";

import { ImageType } from "@/sections/BaliBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from "swiper/modules";

import "swiper/css/effect-fade";
import CustomImage from "../CustomImage";

type BackgroundImageCarouselLoopProps = {
  images: ImageType[];
};

const BackgroundImageCarouselLoop = ({
  images,
}: BackgroundImageCarouselLoopProps) => {
  return (
    <div className="bg-carousel">
      <Swiper
        effect={"fade"}
        loop={true}
        autoplay={true}
        modules={[EffectFade, Autoplay]}
        speed={2000}
      >
        {images.map((image) => (
          <SwiperSlide key={image.image.src.desktop}>
            <CustomImage
              alt={image.image.alt}
              src={image.image.src.desktop}
              srcTablet={image.image.src.tablet}
              srcMobile={image.image.src.mobile}
              className="image--bg"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BackgroundImageCarouselLoop;
